/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useState } from "react";
import Title from "../../ui/Title";
import Stack from "../../ui/Stack";
import FormGroup from "../../ui/form/FormGroup";
import { RadioCardItem, RadioCardsGroup } from "../../ui/RadioCards";
import CustomTipModal from "./CustomTipModal";
import T from "../../ui/Translation";
import FormatPrice from "../../formatters/FormatPrice";
import { useTipSelection } from "../../../hooks/checkout/useTipSelection";

const TipSelection = ({ invoice }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { tipPercentageValues, addTipsToInvoice, isPending, visibleError } = useTipSelection();

  const handleTipSelect = (value) => {
    addTipsToInvoice(value);
  };

  const handleCustomTipSubmit = async (tipAmount) => {
    await addTipsToInvoice(tipAmount);
    setIsModalOpen(false);
  };

  return (
    <Stack $gap="0.25rem">
      <Title size="h3">Tips</Title>
      <FormGroup>
        <RadioCardsGroup label="Do you want to leave a tip?">
          <RadioCardItem value="0" onClick={handleTipSelect}>
            <T>No tip</T>
          </RadioCardItem>
          {tipPercentageValues.map((tip) => (
            <RadioCardItem key={tip.value} value={tip.value} onClick={handleTipSelect}>
              <FormatPrice value={tip.value} currency={invoice.currency} />
            </RadioCardItem>
          ))}
          <RadioCardItem value="custom" onClick={() => setIsModalOpen(true)}>
            <T>Custom</T>
          </RadioCardItem>
        </RadioCardsGroup>
      </FormGroup>

      <CustomTipModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleCustomTipSubmit}
        currency={invoice.currency}
        isPending={isPending}
        visibleError={visibleError}
      />
    </Stack>
  );
};

export default TipSelection;
